// import React, { useState, useEffect, useContext } from 'react';

const FactsEditPublisher = () => {
  return null;
};

export default FactsEditPublisher;
